<template>
  <PublicLayout page-title="Contacto" :show-mobile-cta="false">
    <section class="min-h-[calc(100vh-10rem)]">
      <div class="grid lg:grid-cols-5 min-h-[calc(100vh-10rem)]">
        <!-- Info Panel -->
        <div class="lg:col-span-2 bg-gradient-to-br from-accent-500 to-teal-600 p-8 lg:p-12 flex flex-col justify-center relative overflow-hidden">
          <!-- Decorative blobs -->
          <div class="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div class="absolute bottom-0 left-0 w-64 h-64 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2" />

          <div class="relative z-10">
            <h1 class="text-4xl lg:text-5xl font-bold text-white mb-4 animate-fade-up">
              Hablemos
            </h1>
            <p class="text-white/80 text-lg mb-12 animate-fade-up delay-100">
              Estamos aquí para ayudarte con cualquier consulta sobre nuestros servicios legales
            </p>

            <!-- Contact Info Cards -->
            <div class="space-y-4 animate-fade-up delay-200">
              <div class="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div class="flex items-center gap-4">
                  <div class="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                    <EnvelopeIcon class="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p class="text-white/60 text-sm">Email</p>
                    <a href="mailto:info@olvidadme.com" class="text-white font-medium hover:underline">
                      info@olvidadme.com
                    </a>
                  </div>
                </div>
              </div>

              <div class="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div class="flex items-center gap-4">
                  <div class="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                    <ClockIcon class="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p class="text-white/60 text-sm">Horario</p>
                    <p class="text-white font-medium">L-V: 9:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Trust Badges -->
            <div class="mt-12 flex flex-wrap gap-3 animate-fade-up delay-300">
              <div class="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-sm text-white/80">
                <ShieldCheckIcon class="w-4 h-4" />
                GDPR Compliant
              </div>
              <div class="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-sm text-white/80">
                <LockClosedIcon class="w-4 h-4" />
                Datos Encriptados
              </div>
            </div>
          </div>
        </div>

        <!-- Form Panel -->
        <div class="lg:col-span-3 p-8 lg:p-12 flex items-center justify-center bg-white">
          <div class="w-full max-w-xl">
            <ContactForm
              :use-router-link="true"
              @success="onFormSuccess"
            >
              <template #header>
                <h2 class="text-2xl font-bold text-text-primary mb-2">
                  Envíanos un mensaje
                </h2>
                <p class="text-text-secondary mb-8">
                  Completa el formulario y te responderemos lo antes posible
                </p>
              </template>
            </ContactForm>
          </div>
        </div>
      </div>
    </section>
  </PublicLayout>
</template>

<script setup>
import { useSeo } from '@/composables/useSeo'
import PublicLayout from '@/components/layout/PublicLayout.vue'
import ContactForm from '@/components/support/ContactForm.vue'

// SEO Meta Tags
useSeo({
  title: 'Contacto',
  description: 'Contacta con nuestro equipo legal. Consultas sobre privacidad digital.',
  canonical: '/support/contact'
})
import {
  EnvelopeIcon,
  ClockIcon,
  ShieldCheckIcon,
  LockClosedIcon
} from '@heroicons/vue/24/outline'

const onFormSuccess = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<style scoped>
@reference "../../assets/styles/main.css";

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .animate-fade-up {
    animation: none;
  }

  .hover\:scale-\[1\.02\]:hover {
    transform: none;
  }
}
</style>
